import { send } from 'server';

import * as helpers from './helpers';

export const getBalanceHistory = (params) => {
    const { showTotalTransactionHistory, startDate, endDate, showBeginEndBalanceEnabled } = params;

    return send({
        ID: 32012,
        responses: [32013, 32014],
        description: 'Get balance history',
        startDate: helpers.formatDate(startDate),
        endDate: helpers.formatDate(endDate),
        ignorePlayerViewConf: true,
        returnSummary: showTotalTransactionHistory,
        ignoreStartingEndingBalances: !showBeginEndBalanceEnabled
    });
};

export const getTransactionHistory = (params) => {
    const { startDate, endDate, type, status, pageId, pageSize } = params;

    return send({
        ID: 35610,
        responses: [35611, 35612],
        description: 'Get detailed transaction history',
        startTime: helpers.formatDate(startDate),
        endTime: helpers.formatDate(endDate),
        corrections: true,
        cancellations: true,
        excludePaymentRequests: false,
        pagingRequestParams: {
            pageId,
            pageSize,
            returnTotalCount: true,
            returnAllPageIds: true
        },
        historyRequestSummary: {
            transactionsSummary: true,
            totalDeposits: true,
            totalWithdrawals: true,
            pageTotalDeposits: true,
            pageTotalWithdrawals: true
        },
        ...status && status !== 'all' && { status },
        ...type && type !== 'all' && { type }
    });
};
